// This file is AUTOGENERATED, do not edit it manually!!!

import { commonClient as commonClientde } from './commonClientResx.de';
import { commonClient as commonClienten } from './commonClientResx.en';
import { commonClient as commonClienten_risk } from './commonClientResx.en_risk';
import { commonClient as commonClientes } from './commonClientResx.es';
import { commonClient as commonClientfr } from './commonClientResx.fr';
import { commonClient as commonClientit } from './commonClientResx.it';
import { commonClient as commonClientnl } from './commonClientResx.nl';
import { commonClient as commonClientpl } from './commonClientResx.pl';
import { commonClient as commonClientpt } from './commonClientResx.pt';
import { commonClient as commonClientru } from './commonClientResx.ru';
import { commonClient as commonClientsk } from './commonClientResx.sk';
import { commonClient as commonClientsv } from './commonClientResx.sv';
import { commonClient as commonClienttr } from './commonClientResx.tr';

const langMap: { [k: string]: Partial<typeof commonClienten> } = {
    de: commonClientde,
    en: commonClienten,
    en_risk: commonClienten_risk,
    es: commonClientes,
    fr: commonClientfr,
    it: commonClientit,
    nl: commonClientnl,
    pl: commonClientpl,
    pt: commonClientpt,
    ru: commonClientru,
    sk: commonClientsk,
    sv: commonClientsv,
    tr: commonClienttr,
};

/* tslint:disable: max-line-length */
export const commonClientResx = {
    /**
    * en: About {0}
    */
    get about_item() {
        return langMap[ep.resxCulture].about_item || langMap.en.about_item;
    },
    /**
    * en: Add
    */
    get add() {
        return langMap[ep.resxCulture].add || langMap.en.add;
    },
    /**
    * en: Upgrade now
    */
    get AddMoreSpace() {
        return langMap[ep.resxCulture].AddMoreSpace || langMap.en.AddMoreSpace;
    },
    /**
    * en: All projects
    */
    get all_projects_label() {
        return langMap[ep.resxCulture].all_projects_label || langMap.en.all_projects_label;
    },
    /**
    * en: Parallel approval
    */
    get approval_all_label() {
        return langMap[ep.resxCulture].approval_all_label || langMap.en.approval_all_label;
    },
    /**
    * en: All assigned approvers must approve for the expense to be approved.
    */
    get approval_all_tooltip() {
        return langMap[ep.resxCulture].approval_all_tooltip || langMap.en.approval_all_tooltip;
    },
    /**
    * en: Initial approval
    */
    get approval_one_label() {
        return langMap[ep.resxCulture].approval_one_label || langMap.en.approval_one_label;
    },
    /**
    * en: Approved by any one user. No further approvals needed.
    */
    get approval_one_tooltip() {
        return langMap[ep.resxCulture].approval_one_tooltip || langMap.en.approval_one_tooltip;
    },
    /**
    * en: Archive
    */
    get archive_action_text() {
        return langMap[ep.resxCulture].archive_action_text || langMap.en.archive_action_text;
    },
    /**
    * en: Date archived
    */
    get archive_date_label() {
        return langMap[ep.resxCulture].archive_date_label || langMap.en.archive_date_label;
    },
    /**
    * en: Archived by
    */
    get archived_by_label() {
        return langMap[ep.resxCulture].archived_by_label || langMap.en.archived_by_label;
    },
    /**
    * en: Attach file
    */
    get Attach() {
        return langMap[ep.resxCulture].Attach || langMap.en.Attach;
    },
    /**
    * en: Attach file or image
    */
    get attach_file_image() {
        return langMap[ep.resxCulture].attach_file_image || langMap.en.attach_file_image;
    },
    /**
    * en: Please contact <a href='mailto:billing@birdviewpsa.com'>billing@birdviewpsa.com</a> if you'd like to use a payment method other than a debit card.
    */
    get automation_purchase_notes() {
        return langMap[ep.resxCulture].automation_purchase_notes || langMap.en.automation_purchase_notes;
    },
    /**
    * en:  and see Birdview automation in action!
    */
    get automation_trial_description_end() {
        return langMap[ep.resxCulture].automation_trial_description_end || langMap.en.automation_trial_description_end;
    },
    /**
    * en: 30-day free trial
    */
    get automation_trial_description_middle() {
        return langMap[ep.resxCulture].automation_trial_description_middle || langMap.en.automation_trial_description_middle;
    },
    /**
    * en: Start with our 
    */
    get automation_trial_description_start() {
        return langMap[ep.resxCulture].automation_trial_description_start || langMap.en.automation_trial_description_start;
    },
    /**
    * en: Your trial has expired.
    */
    get automation_trial_expired() {
        return langMap[ep.resxCulture].automation_trial_expired || langMap.en.automation_trial_expired;
    },
    /**
    * en: Please reach out to our <a href='mailto:support@birdviewpsa.com'>support@birdviewpsa.com</a> for further assistance.
    */
    get automation_trial_expired_notes() {
        return langMap[ep.resxCulture].automation_trial_expired_notes || langMap.en.automation_trial_expired_notes;
    },
    /**
    * en: Reload
    */
    get btn_reload() {
        return langMap[ep.resxCulture].btn_reload || langMap.en.btn_reload;
    },
    /**
    * en: Buy subscription
    */
    get buy_subscription() {
        return langMap[ep.resxCulture].buy_subscription || langMap.en.buy_subscription;
    },
    /**
    * en: Cancel
    */
    get Cancel() {
        return langMap[ep.resxCulture].Cancel || langMap.en.Cancel;
    },
    /**
    * en: Change
    */
    get change() {
        return langMap[ep.resxCulture].change || langMap.en.change;
    },
    /**
    * en: Multi-select
    */
    get checkbox_list_text() {
        return langMap[ep.resxCulture].checkbox_list_text || langMap.en.checkbox_list_text;
    },
    /**
    * en: Close
    */
    get Close() {
        return langMap[ep.resxCulture].Close || langMap.en.Close;
    },
    /**
    * en: You have specified that this activity is 100% complete. Do you want to complete the activity? Press 'OK' to change status, or 'Cancel' otherwise.
    */
    get completeActivityConfirm() {
        return langMap[ep.resxCulture].completeActivityConfirm || langMap.en.completeActivityConfirm;
    },
    /**
    * en: Do you want to complete this activity?
    */
    get completeActivityTitle() {
        return langMap[ep.resxCulture].completeActivityTitle || langMap.en.completeActivityTitle;
    },
    /**
    * en: You have specified that this project is 100% complete. Do you want to complete this project? Press 'OK' to change the status.
    */
    get completeProjectConfirm() {
        return langMap[ep.resxCulture].completeProjectConfirm || langMap.en.completeProjectConfirm;
    },
    /**
    * en: Do you want to complete this project?
    */
    get completeProjectTitle() {
        return langMap[ep.resxCulture].completeProjectTitle || langMap.en.completeProjectTitle;
    },
    /**
    * en: Completing this activity will leave no uncompleted activities on this project (parent activity). Would you like to complete the project or parent activity, whichever appropriate, too?
    */
    get confirmCompleteActivityParents() {
        return langMap[ep.resxCulture].confirmCompleteActivityParents || langMap.en.confirmCompleteActivityParents;
    },
    /**
    * en: Set status for {0} as completed?
    */
    get confirmCompleteActivityParentsTitle() {
        return langMap[ep.resxCulture].confirmCompleteActivityParentsTitle || langMap.en.confirmCompleteActivityParentsTitle;
    },
    /**
    * en: Contact us
    */
    get contact_us() {
        return langMap[ep.resxCulture].contact_us || langMap.en.contact_us;
    },
    /**
    * en: Continue
    */
    get continue() {
        return langMap[ep.resxCulture].continue || langMap.en.continue;
    },
    /**
    * en: Copied
    */
    get copied_label() {
        return langMap[ep.resxCulture].copied_label || langMap.en.copied_label;
    },
    /**
    * en: Link copied.
    */
    get copy_link_feedback() {
        return langMap[ep.resxCulture].copy_link_feedback || langMap.en.copy_link_feedback;
    },
    /**
    * en: Copying
    */
    get copying_label() {
        return langMap[ep.resxCulture].copying_label || langMap.en.copying_label;
    },
    /**
    * en: Copy link
    */
    get copyLink() {
        return langMap[ep.resxCulture].copyLink || langMap.en.copyLink;
    },
    /**
    * en: Custom field
    */
    get custom_field_label() {
        return langMap[ep.resxCulture].custom_field_label || langMap.en.custom_field_label;
    },
    /**
    * en: Custom form
    */
    get custom_form_label() {
        return langMap[ep.resxCulture].custom_form_label || langMap.en.custom_form_label;
    },
    /**
    * en: Date
    */
    get date_text() {
        return langMap[ep.resxCulture].date_text || langMap.en.date_text;
    },
    /**
    * en: d
    */
    get DayAbbreviation() {
        return langMap[ep.resxCulture].DayAbbreviation || langMap.en.DayAbbreviation;
    },
    /**
    * en: 1#day#days
    */
    get DayPluralFormat() {
        return langMap[ep.resxCulture].DayPluralFormat || langMap.en.DayPluralFormat;
    },
    /**
    * en: 1#{0} day#{0} days
    */
    get DayPluralFormatTemplate() {
        return langMap[ep.resxCulture].DayPluralFormatTemplate || langMap.en.DayPluralFormatTemplate;
    },
    /**
    * en: Delete
    */
    get Delete() {
        return langMap[ep.resxCulture].Delete || langMap.en.Delete;
    },
    /**
    * en: This action cannot be undone.
    */
    get delete_confirmation() {
        return langMap[ep.resxCulture].delete_confirmation || langMap.en.delete_confirmation;
    },
    /**
    * en: Delete permanently
    */
    get delete_permanently_text() {
        return langMap[ep.resxCulture].delete_permanently_text || langMap.en.delete_permanently_text;
    },
    /**
    * en: for {0}
    */
    get description_information() {
        return langMap[ep.resxCulture].description_information || langMap.en.description_information;
    },
    /**
    * en: Disabled
    */
    get disabled() {
        return langMap[ep.resxCulture].disabled || langMap.en.disabled;
    },
    /**
    * en: (disabled)
    */
    get disabledUserText() {
        return langMap[ep.resxCulture].disabledUserText || langMap.en.disabledUserText;
    },
    /**
    * en: Download
    */
    get Download() {
        return langMap[ep.resxCulture].Download || langMap.en.Download;
    },
    /**
    * en: Dropdown
    */
    get dropdown_text() {
        return langMap[ep.resxCulture].dropdown_text || langMap.en.dropdown_text;
    },
    /**
    * en: Duplicate
    */
    get Duplicate() {
        return langMap[ep.resxCulture].Duplicate || langMap.en.Duplicate;
    },
    /**
    * en: Edit
    */
    get Edit() {
        return langMap[ep.resxCulture].Edit || langMap.en.Edit;
    },
    /**
    * en: {0} ago
    */
    get ElapsedTime_Ago() {
        return langMap[ep.resxCulture].ElapsedTime_Ago || langMap.en.ElapsedTime_Ago;
    },
    /**
    * en: Enabled
    */
    get enabled() {
        return langMap[ep.resxCulture].enabled || langMap.en.enabled;
    },
    /**
    * en: Category
    */
    get Entity_Category() {
        return langMap[ep.resxCulture].Entity_Category || langMap.en.Entity_Category;
    },
    /**
    * en: Customer
    */
    get Entity_Customer() {
        return langMap[ep.resxCulture].Entity_Customer || langMap.en.Entity_Customer;
    },
    /**
    * en: Invoice
    */
    get Entity_Invoice() {
        return langMap[ep.resxCulture].Entity_Invoice || langMap.en.Entity_Invoice;
    },
    /**
    * en: Issue
    */
    get Entity_Issue() {
        return langMap[ep.resxCulture].Entity_Issue || langMap.en.Entity_Issue;
    },
    /**
    * en: Job role
    */
    get Entity_JobRole() {
        return langMap[ep.resxCulture].Entity_JobRole || langMap.en.Entity_JobRole;
    },
    /**
    * en: OAuth client
    */
    get Entity_OAuthAccountClient() {
        return langMap[ep.resxCulture].Entity_OAuthAccountClient || langMap.en.Entity_OAuthAccountClient;
    },
    /**
    * en: Portfolio
    */
    get Entity_Portfolio() {
        return langMap[ep.resxCulture].Entity_Portfolio || langMap.en.Entity_Portfolio;
    },
    /**
    * en: Priority
    */
    get Entity_Priority() {
        return langMap[ep.resxCulture].Entity_Priority || langMap.en.Entity_Priority;
    },
    /**
    * en: Project
    */
    get Entity_Project() {
        return langMap[ep.resxCulture].Entity_Project || langMap.en.Entity_Project;
    },
    /**
    * en: Status
    */
    get Entity_ProjectStatus() {
        return langMap[ep.resxCulture].Entity_ProjectStatus || langMap.en.Entity_ProjectStatus;
    },
    /**
    * en: Request
    */
    get Entity_Request() {
        return langMap[ep.resxCulture].Entity_Request || langMap.en.Entity_Request;
    },
    /**
    * en: Task
    */
    get Entity_Task() {
        return langMap[ep.resxCulture].Entity_Task || langMap.en.Entity_Task;
    },
    /**
    * en: Status
    */
    get Entity_TaskStatus() {
        return langMap[ep.resxCulture].Entity_TaskStatus || langMap.en.Entity_TaskStatus;
    },
    /**
    * en: User
    */
    get Entity_User() {
        return langMap[ep.resxCulture].Entity_User || langMap.en.Entity_User;
    },
    /**
    * en: Operation could not be completed for the following reason(s): item (type: {entityName}, ID: {objectKey}) not found in the database.  This may be due to the deletion of, or lacking permission to view the item. Consult with your {brandName} administrator for possible causes.
    */
    get Error_CantFindObjectTemplate() {
        return langMap[ep.resxCulture].Error_CantFindObjectTemplate || langMap.en.Error_CantFindObjectTemplate;
    },
    /**
    * en: An object or user involved having been deleted or access permissions revoked by another user.
    */
    get error_notFullyCompleted() {
        return langMap[ep.resxCulture].error_notFullyCompleted || langMap.en.error_notFullyCompleted;
    },
    /**
    * en: The uploading of the file {0} could not be completed, because you cannot upload a file larger than ∼ {1} GB
    */
    get ErrorFileSizeLimit() {
        return langMap[ep.resxCulture].ErrorFileSizeLimit || langMap.en.ErrorFileSizeLimit;
    },
    /**
    * en: The uploading of the file {0} could not be completed, because your account has run out of space.
    */
    get ErrorUploadExceededText() {
        return langMap[ep.resxCulture].ErrorUploadExceededText || langMap.en.ErrorUploadExceededText;
    },
    /**
    * en: The uploading of the file {0} met with an unknown error and could not be completed. Please repeat the uploading process.
    */
    get ErrorUploadText() {
        return langMap[ep.resxCulture].ErrorUploadText || langMap.en.ErrorUploadText;
    },
    /**
    * en: Error uploading file.
    */
    get ErrorUploadTitle() {
        return langMap[ep.resxCulture].ErrorUploadTitle || langMap.en.ErrorUploadTitle;
    },
    /**
    * en: The file you're attempting to attach may contain a virus. Please remove the file and perform a computer scan for your safety.
    */
    get ErrorVirusText() {
        return langMap[ep.resxCulture].ErrorVirusText || langMap.en.ErrorVirusText;
    },
    /**
    * en: Virus file
    */
    get ErrorVirusTitle() {
        return langMap[ep.resxCulture].ErrorVirusTitle || langMap.en.ErrorVirusTitle;
    },
    /**
    * en: Exported
    */
    get exported() {
        return langMap[ep.resxCulture].exported || langMap.en.exported;
    },
    /**
    * en: Exporting
    */
    get exporting() {
        return langMap[ep.resxCulture].exporting || langMap.en.exporting;
    },
    /**
    * en: Failed
    */
    get failed() {
        return langMap[ep.resxCulture].failed || langMap.en.failed;
    },
    /**
    * en: Help
    */
    get help() {
        return langMap[ep.resxCulture].help || langMap.en.help;
    },
    /**
    * en: h
    */
    get HourAbbreviation() {
        return langMap[ep.resxCulture].HourAbbreviation || langMap.en.HourAbbreviation;
    },
    /**
    * en: 1#hour#hours
    */
    get HourPluralFormat() {
        return langMap[ep.resxCulture].HourPluralFormat || langMap.en.HourPluralFormat;
    },
    /**
    * en: 1#{0} hour#{0} hours
    */
    get HourPluralFormatTemplate() {
        return langMap[ep.resxCulture].HourPluralFormatTemplate || langMap.en.HourPluralFormatTemplate;
    },
    /**
    * en: CTRL+Click to follow link
    */
    get HyperLinkTooltip() {
        return langMap[ep.resxCulture].HyperLinkTooltip || langMap.en.HyperLinkTooltip;
    },
    /**
    * en: 1#{0} item selected#{0} items selected
    */
    get items_selected_plural() {
        return langMap[ep.resxCulture].items_selected_plural || langMap.en.items_selected_plural;
    },
    /**
    * en: Powered by
    */
    get madeBy() {
        return langMap[ep.resxCulture].madeBy || langMap.en.madeBy;
    },
    /**
    * en: m
    */
    get MinuteAbbreviation() {
        return langMap[ep.resxCulture].MinuteAbbreviation || langMap.en.MinuteAbbreviation;
    },
    /**
    * en: 1#{0} min#{0} min
    */
    get MinutePluralFormat() {
        return langMap[ep.resxCulture].MinutePluralFormat || langMap.en.MinutePluralFormat;
    },
    /**
    * en: and {0} more
    */
    get more_counter_text() {
        return langMap[ep.resxCulture].more_counter_text || langMap.en.more_counter_text;
    },
    /**
    * en: Next
    */
    get next() {
        return langMap[ep.resxCulture].next || langMap.en.next;
    },
    /**
    * en: No items selected
    */
    get no_items_selected() {
        return langMap[ep.resxCulture].no_items_selected || langMap.en.no_items_selected;
    },
    /**
    * en: None
    */
    get None_Text() {
        return langMap[ep.resxCulture].None_Text || langMap.en.None_Text;
    },
    /**
    * en: Not set
    */
    get Not_set() {
        return langMap[ep.resxCulture].Not_set || langMap.en.Not_set;
    },
    /**
    * en: OK
    */
    get Ok() {
        return langMap[ep.resxCulture].Ok || langMap.en.Ok;
    },
    /**
    * en: Sequential approval
    */
    get one_after_another_label() {
        return langMap[ep.resxCulture].one_after_another_label || langMap.en.one_after_another_label;
    },
    /**
    * en: Approvers must approve in a set order, one after another
    */
    get one_after_another_tooltip() {
        return langMap[ep.resxCulture].one_after_another_tooltip || langMap.en.one_after_another_tooltip;
    },
    /**
    * en: Open details in new tab
    */
    get open_details_new_tab() {
        return langMap[ep.resxCulture].open_details_new_tab || langMap.en.open_details_new_tab;
    },
    /**
    * en: Open in new tab
    */
    get open_in_new_tab() {
        return langMap[ep.resxCulture].open_in_new_tab || langMap.en.open_in_new_tab;
    },
    /**
    * en: Opening...
    */
    get OpeningWindow() {
        return langMap[ep.resxCulture].OpeningWindow || langMap.en.OpeningWindow;
    },
    /**
    * en: Open original
    */
    get OpenOriginal() {
        return langMap[ep.resxCulture].OpenOriginal || langMap.en.OpenOriginal;
    },
    /**
    * en: The operation could not be completed
    */
    get OperationError_Title() {
        return langMap[ep.resxCulture].OperationError_Title || langMap.en.OperationError_Title;
    },
    /**
    * en: Paragraph text
    */
    get paragraph_text() {
        return langMap[ep.resxCulture].paragraph_text || langMap.en.paragraph_text;
    },
    /**
    * en: parent activity
    */
    get parentActivity() {
        return langMap[ep.resxCulture].parentActivity || langMap.en.parentActivity;
    },
    /**
    * en: per day
    */
    get PerDay() {
        return langMap[ep.resxCulture].PerDay || langMap.en.PerDay;
    },
    /**
    * en: per week
    */
    get PerWeek() {
        return langMap[ep.resxCulture].PerWeek || langMap.en.PerWeek;
    },
    /**
    * en: Project custom fields
    */
    get project_custom_fields_label() {
        return langMap[ep.resxCulture].project_custom_fields_label || langMap.en.project_custom_fields_label;
    },
    /**
    * en: Remove
    */
    get Remove() {
        return langMap[ep.resxCulture].Remove || langMap.en.Remove;
    },
    /**
    * en: Request has been sent successfully. Success team will contact you.
    */
    get request_has_been_sent_successfully() {
        return langMap[ep.resxCulture].request_has_been_sent_successfully || langMap.en.request_has_been_sent_successfully;
    },
    /**
    * en: Try it now
    */
    get Request_Trial() {
        return langMap[ep.resxCulture].Request_Trial || langMap.en.Request_Trial;
    },
    /**
    * en: Reset
    */
    get Reset() {
        return langMap[ep.resxCulture].Reset || langMap.en.Reset;
    },
    /**
    * en: Save
    */
    get Save() {
        return langMap[ep.resxCulture].Save || langMap.en.Save;
    },
    /**
    * en: Saved
    */
    get saved() {
        return langMap[ep.resxCulture].saved || langMap.en.saved;
    },
    /**
    * en: Saving
    */
    get saving() {
        return langMap[ep.resxCulture].saving || langMap.en.saving;
    },
    /**
    * en: Search
    */
    get Search() {
        return langMap[ep.resxCulture].Search || langMap.en.Search;
    },
    /**
    * en: Select...
    */
    get select_placeholder() {
        return langMap[ep.resxCulture].select_placeholder || langMap.en.select_placeholder;
    },
    /**
    * en: Selection mode
    */
    get selection_mode_text() {
        return langMap[ep.resxCulture].selection_mode_text || langMap.en.selection_mode_text;
    },
    /**
    * en: Sending
    */
    get sending() {
        return langMap[ep.resxCulture].sending || langMap.en.sending;
    },
    /**
    * en: Set as Completed
    */
    get setCompleted() {
        return langMap[ep.resxCulture].setCompleted || langMap.en.setCompleted;
    },
    /**
    * en: Show less
    */
    get show_less_label() {
        return langMap[ep.resxCulture].show_less_label || langMap.en.show_less_label;
    },
    /**
    * en: Show more
    */
    get show_more_label() {
        return langMap[ep.resxCulture].show_more_label || langMap.en.show_more_label;
    },
    /**
    * en: There's not enough available storage space to store files.
    */
    get space_exceeded_description() {
        return langMap[ep.resxCulture].space_exceeded_description || langMap.en.space_exceeded_description;
    },
    /**
    * en: Storage is full
    */
    get space_exceeded_title() {
        return langMap[ep.resxCulture].space_exceeded_title || langMap.en.space_exceeded_title;
    },
    /**
    * en: Submit
    */
    get submit() {
        return langMap[ep.resxCulture].submit || langMap.en.submit;
    },
    /**
    * en: Please contact <a href='mailto:success@birdviewpsa.com'>success@birdviewpsa.com</a> to clarify your subscription status.
    */
    get subscribe_trouble_description() {
        return langMap[ep.resxCulture].subscribe_trouble_description || langMap.en.subscribe_trouble_description;
    },
    /**
    * en: Summary
    */
    get summary() {
        return langMap[ep.resxCulture].summary || langMap.en.summary;
    },
    /**
    * en: Enter time e.g. 2h 30m
    */
    get time_input_placeholder() {
        return langMap[ep.resxCulture].time_input_placeholder || langMap.en.time_input_placeholder;
    },
    /**
    * en: 1#{0} second#{0} seconds
    */
    get timer_text() {
        return langMap[ep.resxCulture].timer_text || langMap.en.timer_text;
    },
    /**
    * en: The operation could not be completed partially or in full
    */
    get title_notFullyCompleted() {
        return langMap[ep.resxCulture].title_notFullyCompleted || langMap.en.title_notFullyCompleted;
    },
    /**
    * en: Please, reload the page
    */
    get title_reload() {
        return langMap[ep.resxCulture].title_reload || langMap.en.title_reload;
    },
    /**
    * en: Total
    */
    get total() {
        return langMap[ep.resxCulture].total || langMap.en.total;
    },
    /**
    * en: Turn off
    */
    get turn_off() {
        return langMap[ep.resxCulture].turn_off || langMap.en.turn_off;
    },
    /**
    * en: Type
    */
    get type() {
        return langMap[ep.resxCulture].type || langMap.en.type;
    },
    /**
    * en: Type to search
    */
    get Type_for_search() {
        return langMap[ep.resxCulture].Type_for_search || langMap.en.Type_for_search;
    },
    /**
    * en: Type to search or add
    */
    get Type_for_search_or_add() {
        return langMap[ep.resxCulture].Type_for_search_or_add || langMap.en.Type_for_search_or_add;
    },
    /**
    * en: Type to search or create
    */
    get Type_for_search_or_create() {
        return langMap[ep.resxCulture].Type_for_search_or_create || langMap.en.Type_for_search_or_create;
    },
    /**
    * en: Unarchive
    */
    get unarchive_action_text() {
        return langMap[ep.resxCulture].unarchive_action_text || langMap.en.unarchive_action_text;
    },
    /**
    * en: Undoing
    */
    get undoing() {
        return langMap[ep.resxCulture].undoing || langMap.en.undoing;
    },
    /**
    * en: Undone
    */
    get undone() {
        return langMap[ep.resxCulture].undone || langMap.en.undone;
    },
    /**
    * en: Upload
    */
    get upload() {
        return langMap[ep.resxCulture].upload || langMap.en.upload;
    },
    /**
    * en: enable desktop notifications.
    */
    get WebPushNotificationPanelLink() {
        return langMap[ep.resxCulture].WebPushNotificationPanelLink || langMap.en.WebPushNotificationPanelLink;
    },
    /**
    * en: {brandName} needs your permission to 
    */
    get WebPushNotificationPanelText() {
        return langMap[ep.resxCulture].WebPushNotificationPanelText || langMap.en.WebPushNotificationPanelText;
    },
    /**
    * en: (you)
    */
    get you_user_text() {
        return langMap[ep.resxCulture].you_user_text || langMap.en.you_user_text;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.commonClient = commonClientResx;
